import { render, staticRenderFns } from "./CertificationFormCurrent.vue?vue&type=template&id=30c9843c"
import script from "./CertificationFormCurrent.vue?vue&type=script&lang=js"
export * from "./CertificationFormCurrent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports